
















































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { DELETE_ADDRESSES_PROJECT_ADDRESS, FETCH_ADDRESSES_PROJECT_ADDRESS } from '@/store/action-types'
import DeleteDialog from '@/components/DeleteDialog.vue'
import ProjectAddressDialog from '@/components/master-data/address/ProjectAddressDialog.vue'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import { AddressProjectAddressResponse, SaveUpdateDeleteProjectAddressResponse } from '@/types/service-response'
import { AddressProjectAddress } from '@/model/addresses/AddressProjectAddress'
import { AddressArt } from '@/model/addresses/AddressArt'
import { AddressDispCode } from '@/model/addresses/AddressDispCode'
import { DeleteProjectAddressRequestPayload } from '@/types/payload'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  gridOptions: any
  overlayNoRowsTemplate: string
  gridData: AddressProjectAddress[]
  selectedProjectAddress: AddressProjectAddress | undefined
  showDeleteDialog: boolean
  showDialog: boolean

  addressArtList: AddressArt[]
  addressDispCodeList: AddressDispCode[]

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'AddressProjectAddress',

  components: {
    AgGridVue,
    DeleteDialog,
    ProjectAddressDialog
  },

  props: {
    addressId:{
      type: Number,
      default: undefined
    }
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      gridOptions: {
        defaultColDef: {
          resizable: true,
        },
        columnDefs: [
          { headerName: this.$t('masterData.addresses.projectAddress.code'), field: 'code', width: 100, maxWidth: 100},
          { headerName: this.$t('masterData.addresses.projectAddress.addressArt'), field: 'adressArt', width: 200, maxWidth: 200},
          { headerName: this.$t('masterData.addresses.projectAddress.processStepType'), field: 'prozessSchrittTyp', width: 200, maxWidth: 200},
          { headerName: this.$t('masterData.addresses.projectAddress.addressNumber'), field: 'adressnummer', width: 150, maxWidth: 150},
          { headerName: this.$t('masterData.addresses.projectAddress.addressLine'), field: 'adressLinie', width: 300}
        ]
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      gridData: [],
      selectedProjectAddress: undefined,
      showDeleteDialog: false,
      showDialog: false,
      addressArtList: [],
      addressDispCodeList: [],

      keyActions: []
    }
  },

  watch: {
    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isEnableProjectAddressButtons (): boolean {
      return !!this.selectedProjectAddress
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableProjectAddressButtons
      } else if(action instanceof Delete) {
        return this.isEnableProjectAddressButtons
      } else {
        return false
      }
    },

    onProjectAddressRowClicked (params: any): void {
      this.selectedProjectAddress = params.data
    },

    onAddProjectAddressClick (): void {
      this.selectedProjectAddress = undefined
      this.showDialog = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddProjectAddressClick()
    },

    onEditProjectAddressClick (): void {
      this.showDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditProjectAddressClick()
    },

    dialogSaved (): void {
      this.showDialog = false
      this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
      this.snackbarState = SnackbarStateEnum.Success
      this.showSnackbar = true
      this.fetchData()
    },

    closeDialog (): void {
      this.showDialog = false
    },

    onDeleteProjectAddressClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteProjectAddressClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      const payload: DeleteProjectAddressRequestPayload = {
        AdressSchritteID: this.selectedProjectAddress!.adressSchritteId
      }

      this.deleteProjectAddress(payload)
    },

    async deleteProjectAddress (payload: DeleteProjectAddressRequestPayload): Promise<void> {
      try {
        let response: SaveUpdateDeleteProjectAddressResponse = await this.$store.dispatch(DELETE_ADDRESSES_PROJECT_ADDRESS, payload)
        if(response && !response.IsError) {
          this.onDeleteDialogClose()
          this.selectedProjectAddress = undefined
          this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchData()
        } else {
          this.onDeleteDialogClose()
          this.selectedProjectAddress = undefined
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      const response: AddressProjectAddressResponse = await this.$store.dispatch(FETCH_ADDRESSES_PROJECT_ADDRESS, this.addressId)
      if(response && !response.IsError) {
        this.gridData = AddressProjectAddress.createFromResponse(response.Addresses)
        this.addressArtList = AddressArt.createFromResponse(response.AddressArt)
        this.addressDispCodeList = AddressDispCode.createFromResponse(response.DispCodelistenWerte)
      }
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted (): void {
    window.addEventListener('keydown', this.onKeydown)
    if(this.$vuetify.breakpoint.mdAndUp) {
      this.gridOptions.api.sizeColumnsToFit()
    }
    this.fetchData()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
